import { render, staticRenderFns } from "./PRJ101P03.vue?vue&type=template&id=4c3ed871&"
import script from "./PRJ101P03.vue?vue&type=script&lang=js&"
export * from "./PRJ101P03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports